// Only calculate paths on layout changes. The browser runs the six tiny
// transform/opacity animations without a JavaScript frame loop or SVG repaint.
export function createHeroFlowDots(container, hero) {
  const dots = [...container.querySelectorAll('.hc-flow-dot')];
  const animations = [];
  let paused = true;

  const cancel = () => {
    animations.forEach((animation) => animation?.cancel());
    animations.length = 0;
  };
  const resize = () => {
    const bounds = container.getBoundingClientRect();
    if (!bounds.width || !bounds.height || !dots[0]?.animate) {
      cancel();
      return;
    }

    // Read every anchor before writing keyframes, avoiding read/write reflows.
    const paths = [1, 2, 3].map((slot) => {
      const seller = hero.querySelector(`.hc-chip--${slot} .hc-chip__icon`);
      const airline = hero.querySelector(`.hc-al--${slot}`);
      if (!seller || !airline) return null;
      const start = seller.getBoundingClientRect();
      const end = airline.getBoundingClientRect();
      return {
        startX: start.left + start.width / 2 - bounds.left,
        startY: start.top + start.height / 2 - bounds.top,
        endX: end.left + end.width / 2 - bounds.left,
        endY: end.top + end.height / 2 - bounds.top,
        bend: ((slot === 1 ? -48 : slot === 2 ? -32 : 48) * bounds.height) / 680,
      };
    });
    container.style.setProperty('--hc-dot-size', `${(5 * bounds.width) / 1440}px`);

    dots.forEach((dot, index) => {
      const pair = Math.floor(index / 2);
      const path = paths[pair];
      if (!path) return;
      const { startX, startY, endX, endY, bend } = path;
      const keyframes = Array.from({ length: 33 }, (_, step) => {
        const offset = step / 32;
        const t = index % 2 ? 1 - offset : offset;
        const u = 1 - t;
        const x = startX + (endX - startX) * t;
        const y =
          u ** 3 * startY +
          3 * u ** 2 * t * (startY + bend) +
          3 * u * t ** 2 * (endY + bend) +
          t ** 3 * endY;
        return {
          offset,
          transform: `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`,
          opacity: Math.min(1, offset / 0.06, (1 - offset) / 0.06) * 0.6,
        };
      });
      if (animations[index]) {
        // Keep the current phase when a localized card or viewport resizes.
        animations[index].effect.setKeyframes(keyframes);
      } else {
        const animation = dot.animate(keyframes, {
          duration: [6000, 5500, 7500][pair],
          delay: pair * 350,
          iterations: Infinity,
          easing: 'linear',
          fill: 'both',
        });
        if (paused) animation.pause();
        animations[index] = animation;
      }
    });
  };
  return {
    resize,
    pause() {
      paused = true;
      animations.forEach((animation) => animation?.pause());
    },
    resume() {
      paused = false;
      animations.forEach((animation) => {
        if (animation?.playState === 'paused') animation.play();
      });
    },
    destroy: cancel,
  };
}
